import { Trans } from "@lingui/macro";
import {
  FaFacebookSquare,
  FaTwitterSquare,
  FaInstagramSquare,
  FaDiscord,
  FaWhatsapp,
} from "react-icons/fa";

const FAQHelpChannel: React.FunctionComponent = () => {
  return (
    <>
      <p className="mt-10 mb-5 text-center font-poppins text-3xl font-bold text-primary">
        <Trans>Nothing's working?</Trans>
      </p>
      <p className="mb-5 mr-2 text-center font-sen text-text-dark">
        <Trans>Contact us directly here</Trans>
      </p>
      <div className="mb-6 px-6">
        <div className="mx-auto max-w-sm">
          <a
            href="https://api.whatsapp.com/send/?phone=%2B60123395864&text&type=phone_number&app_absent=0"
            className="mb-5 flex items-center rounded-lg bg-off-white px-4 py-4"
            target="_blank"
          >
            <FaWhatsapp size={24} className="mr-2 h-10 w-10 text-primary" />
            <p className="font-sen text-text-darkest">WhatsApp</p>
          </a>
          <a
            href="https://www.facebook.com/luminews.my/"
            className="mb-5 flex items-center rounded-lg bg-off-white px-4 py-4"
            target="_blank"
          >
            <FaFacebookSquare
              size={24}
              className="mr-2 h-10 w-10 text-primary"
            />
            <p className="font-sen text-text-darkest">Facebook</p>
          </a>
          <a
            href="https://twitter.com/luminewsmy"
            className="mb-5 flex items-center rounded-lg bg-off-white px-4 py-4"
            target="_blank"
          >
            <FaTwitterSquare
              size={24}
              className="mr-2 h-10 w-10 text-primary"
            />
            <p className="font-sen text-text-darkest">Twitter</p>
          </a>
          <a
            href="https://www.instagram.com/luminews.my/"
            className="mb-5 flex items-center rounded-lg bg-off-white px-4 py-4"
            target="_blank"
          >
            <FaInstagramSquare
              size={24}
              className="mr-2 h-10 w-10 text-primary"
            />
            <p className="font-sen text-text-darkest">Instagram</p>
          </a>
          <a
            href="https://bit.ly/luminewsmydiscord"
            className="mb-5 flex items-center rounded-lg bg-off-white px-4 py-4"
            target="_blank"
          >
            <FaDiscord size={24} className="mr-2 h-10 w-10 text-primary" />
            <p className="font-sen text-text-darkest">Discord</p>
          </a>
        </div>
      </div>
      <p className="text-center font-sen text-primary underline">
        <a href="mailto: help@luminews.my">
          <Trans>Email us directly</Trans>
        </a>
      </p>
    </>
  );
};

export default FAQHelpChannel;
